/* cache-bust: 1778190213893 */
/* iBalls DTC v12 — funnel page interactions */
(function(){
  'use strict';

  /* FAQ accordion */
  document.querySelectorAll('.idtc-faq-q').forEach(function(q){
    q.addEventListener('click', function(){
      q.parentElement.classList.toggle('open');
    });
  });

  /* Burger menu */
  var burger = document.getElementById('idtc-navBurger');
  var navLinks = document.getElementById('idtc-navLinks');
  if(burger && navLinks){
    burger.addEventListener('click', function(){
      navLinks.classList.toggle('open');
    });
    navLinks.querySelectorAll('a').forEach(function(a){
      a.addEventListener('click', function(){ navLinks.classList.remove('open'); });
    });
  }

  /* Sticky CTA reveal after hero */
  var sticky = document.getElementById('idtc-sticky');
  if(sticky){
    var hero = document.querySelector('.idtc-hero');
    var heroBottom = 0;
    function calc(){ if(hero){ heroBottom = hero.offsetTop + hero.offsetHeight; } }
    calc();
    window.addEventListener('resize', calc);
    window.addEventListener('scroll', function(){
      sticky.classList.toggle('vis', window.scrollY > heroBottom - 80);
    }, { passive: true });
  }

  /* Gallery thumbs */
  var thumbs = document.querySelectorAll('.idtc-g-thumb');
  thumbs.forEach(function(t){
    t.addEventListener('click', function(){
      thumbs.forEach(function(x){ x.classList.remove('active'); });
      t.classList.add('active');
      var src = t.querySelector('img') ? t.querySelector('img').getAttribute('src') : null;
      var main = document.querySelector('.idtc-hero-gallery-main img');
      if(src && main){ main.src = src; }
    });
  });

  /* Falling leaves canvas */
  (function(){
    var canvas = document.getElementById('idtc-leaves-canvas');
    if(!canvas) return;
    var ctx = canvas.getContext('2d');

    function resize(){
      var rect = canvas.parentElement.getBoundingClientRect();
      canvas.width  = rect.width  || canvas.parentElement.offsetWidth;
      canvas.height = rect.height || canvas.parentElement.offsetHeight;
    }
    resize();
    window.addEventListener('resize', resize);

    function drawLeaf(ctx, x, y, size, angle, alpha, variant){
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle);
      ctx.globalAlpha = alpha;
      if(variant === 0){
        ctx.beginPath();
        ctx.ellipse(0, 0, size * 0.38, size * 0.72, 0, 0, Math.PI * 2);
        ctx.fillStyle = '#3a9d58';
        ctx.fill();
        ctx.beginPath();
        ctx.moveTo(0, -size * 0.7);
        ctx.lineTo(0,  size * 0.7);
        ctx.strokeStyle = 'rgba(255,255,255,0.18)';
        ctx.lineWidth = size * 0.045;
        ctx.stroke();
        for(var i=-1;i<=1;i+=2){
          ctx.beginPath();
          ctx.moveTo(0, -size*0.3);
          ctx.quadraticCurveTo(i*size*0.28, -size*0.1, i*size*0.26, size*0.1);
          ctx.strokeStyle = 'rgba(255,255,255,0.10)';
          ctx.lineWidth = size*0.03;
          ctx.stroke();
        }
      } else {
        ctx.beginPath();
        ctx.moveTo(0, -size * 0.75);
        ctx.bezierCurveTo( size*0.42,  -size*0.2,   size*0.42,  size*0.5,  0,  size*0.75);
        ctx.bezierCurveTo(-size*0.42,   size*0.5,  -size*0.42, -size*0.2,  0, -size*0.75);
        var g = ctx.createLinearGradient(0,-size*0.75,0,size*0.75);
        g.addColorStop(0,  '#5dc47a');
        g.addColorStop(0.5,'#2d7a45');
        g.addColorStop(1,  '#1a5230');
        ctx.fillStyle = g;
        ctx.fill();
        ctx.beginPath();
        ctx.moveTo(0,-size*0.72);
        ctx.lineTo(0, size*0.72);
        ctx.strokeStyle = 'rgba(255,255,255,0.15)';
        ctx.lineWidth = size*0.04;
        ctx.stroke();
      }
      ctx.restore();
    }

    function makeLeaf(){
      var w = canvas.width, h = canvas.height;
      return {
        x:        Math.random() * w * 1.2 - w * 0.1,
        y:        -20 - Math.random() * 80,
        size:     10 + Math.random() * 14,
        speedY:   0.6 + Math.random() * 0.9,
        speedX:  (Math.random() - 0.5) * 0.6,
        angle:    Math.random() * Math.PI * 2,
        rotSpeed:(Math.random() - 0.5) * 0.025,
        swing:    Math.random() * Math.PI * 2,
        swingAmp: 0.4 + Math.random() * 0.7,
        swingSpd: 0.012 + Math.random() * 0.012,
        alpha:    0.55 + Math.random() * 0.35,
        variant:  Math.random() > 0.5 ? 0 : 1
      };
    }

    var MAX_LEAVES = 18;
    var leaves = [];
    for(var i=0;i<MAX_LEAVES;i++){
      var l = makeLeaf();
      l.y = Math.random() * (canvas.height + 40);
      leaves.push(l);
    }

    if(window.matchMedia('(prefers-reduced-motion:reduce)').matches){
      ctx.clearRect(0,0,canvas.width,canvas.height);
      return;
    }

    function tick(){
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      for(var i=0;i<leaves.length;i++){
        var l = leaves[i];
        l.swing  += l.swingSpd;
        l.x      += l.speedX + Math.sin(l.swing) * l.swingAmp;
        l.y      += l.speedY;
        l.angle  += l.rotSpeed;
        drawLeaf(ctx, l.x, l.y, l.size, l.angle, l.alpha, l.variant);
        if(l.y > canvas.height + 20){ leaves[i] = makeLeaf(); }
      }
      requestAnimationFrame(tick);
    }
    tick();
  })();

  /* Scroll reveal */
  (function(){
    var els = document.querySelectorAll('.idtc-reveal');
    if(!els.length || !window.IntersectionObserver) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function(el){ io.observe(el); });
  })();
})();
